// extracted by mini-css-extract-plugin
export default {"wrapper":"ScreenShotsTile_wrapper__ZawPT","screenShots":"ScreenShotsTile_screenShots__oFlWy"};